import {Component, ElementRef, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators, FormGroup, FormBuilder} from '@angular/forms';
import {AppConstant} from '../../../shared/utility/app-constant';
import {AppPatternValidations} from '../../../shared/enums/app-pattern-validations';
import {HttpResponseMessage} from '../../../shared/utility/http-response-message';
import {VendorService} from '../../../shared/services/vendors/vendor.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NotificationService} from '../../../shared/services/notification/notification.service';
import {CommonUtility} from '../../../shared/utility/common-utility';
import {btoa} from 'btoa';
import {VendorAchDetailDto} from '../../../shared/dto/vendor/vendor-ach-detail-dto';
import {MustMatch} from '../../../shared/helpers/password-validate';
import {RemoveSpace} from '../../../shared/helpers/remove-space';
import {PatternValidator} from '../../../shared/helpers/pattern-validator';
import {DropdownDto} from '../../../shared/dto/common/dropDown/dropdown-dto';

@Component({
  selector: 'app-vendor-ach-details',
  templateUrl: './vendor-ach-register.component.html',
  styleUrls: ['./vendor-ach-register.component.scss']
})


export class VendorAchRegisterComponent implements OnInit {

  public vendorACHDetailForm: UntypedFormGroup;
  public expression = new RegExp(AppPatternValidations.EMAIL_PATTERN);
  public vendorAchDetailDto: VendorAchDetailDto = new VendorAchDetailDto();
  public queryParams;
  public encryptedData;
  public isCommunityVendor = false;
  public companyName: string;
  public loading = false;
  private endPoint: string;

  public showDetailForm = true;
  public alreadyCreated = false;
  public oldLinkExpired = false;
  public linkExpired = false;
  public registerSuccess = false;
  public removeSpace: RemoveSpace = new RemoveSpace();
  public recipientType: DropdownDto = new DropdownDto();
  public accountType: DropdownDto = new DropdownDto();

  constructor(public formBuilder: FormBuilder, public vendorService: VendorService,
              public activatedRoute: ActivatedRoute, private el: ElementRef,
              public notificationService: NotificationService, public router: Router) {
  }

  ngOnInit(): void {
    this.accountType.data = AppConstant.PAYMENT_ACCOUNT_TYPES;
    this.recipientType.data = AppConstant.PAYMENT_RECIPIENT_TYPES;
    this.initFormGroup();
    this.validateVendor();
  }

  initFormGroup() {
    this.vendorACHDetailForm = this.formBuilder.group({
      accountType: [null, Validators.compose([Validators.required])],
      recipientType: [null, Validators.compose([Validators.required])],
      companyName: [{value: null, disabled: true}, Validators.compose([Validators.required, Validators.maxLength(50)])],
      accountNumber: [null, Validators.compose([Validators.required, Validators.maxLength(50)])],
      confirmAccountNumber: [null, Validators.required],
      accountRoutingNumber: [null, Validators.compose([Validators.required, Validators.maxLength(9)])],
      confirmRoutingNumber: [null, Validators.compose([Validators.required, Validators.maxLength(9)])],
      remittanceEmail: [AppConstant.NULL_VALUE, [Validators.compose([Validators.maxLength(150),
        PatternValidator.patternValidator(this.expression, {emailValidate: true})])]],
      uuid: [null],
      requestedTenantId: [null],
    }, {
      validator: [
        MustMatch('accountNumber', 'confirmAccountNumber'),
        MustMatch('accountRoutingNumber', 'confirmRoutingNumber'),
      ]
    });


    this.queryParams = this.activatedRoute.snapshot.queryParams;
    this.setQueryParamData();
  }

  get f() {
    return this.vendorACHDetailForm.controls;
  }

  setQueryParamData() {
    if (this.queryParams && this.queryParams.tenantid) {
      this.vendorACHDetailForm.get('requestedTenantId').patchValue(this.queryParams.tenantid);
    }
    if (this.queryParams && this.queryParams.uuid) {
      this.vendorACHDetailForm.get('uuid').patchValue(this.queryParams.uuid);
    }
  }

  /**
   * Validate the states code and navigate the pages
   */
  validateVendor() {
    if (!this.f.uuid.value) {
      return;
    }

    this.vendorService.validateACHDetailRequest(this.f.uuid.value, this.f.requestedTenantId.value).subscribe(
      (res: any) => {
        this.isCommunityVendor = res.body.communityVendor;
        this.companyName = res.body.companyName;
        const companyNameControl = this.vendorACHDetailForm.get('companyName');

        switch (res.status) {
          case AppConstant.HTTP_RESPONSE_STATUS_SUCCESS:
            companyNameControl.setValue(res.body.companyName);
            if (!res.body.companyName) {
              companyNameControl.enable();
            }
            break;

          case AppConstant.HTTP_RESPONSE_STATUS_CREATED:
            // if status is 201 Created(Success) Screen
            this.statusUpdate('C');
            break;
          case 226:
            // if status is 226 send Old Link Expired Screen
            this.statusUpdate('OE');
            break;

          case 208:
            // if status is 208 send Link Expired Screen
            this.statusUpdate('LE');
            break;
        }
      },
      (error) => {
        this.notificationService.errorMessage(error);
      }
    );
  }


  /**
   * This method can be used to submit the form
   */
  onSubmit() {
    if (this.vendorACHDetailForm.valid) {
      this.loading = true;
      const {confirmAccountNumber, confirmRoutingNumber, uuid, requestedTenantId, ...formData} = this.vendorACHDetailForm.value;
      this.vendorAchDetailDto = formData;

      if (this.companyName) {
        this.vendorAchDetailDto.companyName = this.companyName;
      }
      this.encryptedData = window.btoa(JSON.stringify(this.vendorAchDetailDto));

      this.vendorService.saveVendor(this.isCommunityVendor, this.encryptedData, this.f.uuid.value, this.f.requestedTenantId.value)
        .subscribe((res: any) => {
        if (res.status === AppConstant.HTTP_RESPONSE_STATUS_SUCCESS) {
          this.vendorACHDetailForm.reset();
          this.notificationService.successMessage(HttpResponseMessage.VENDOR_ACH_REGISTERED_SUCCESSFULLY);

          setTimeout(() => {
            if (this.isCommunityVendor) {
              this.statusUpdate('CV');
            } else {
              this.statusUpdate('NV');
            }
          }, 800);
        } else {
          this.loading = false;
          this.notificationService.infoMessage(res.body.message);
        }
      }, (error => {
        this.loading = false;
        this.notificationService.errorMessage(error);
      }));
    } else {
      this.loading = false;
      new CommonUtility().scrollToField(new CommonUtility().validateForm(this.vendorACHDetailForm), this.el);
    }
  }

  /**
   * This method can be used to reset the form
   */
  resetForm() {
    this.vendorACHDetailForm.reset();
    this.setQueryParamData();
    this.validateVendor();
  }

  /**
   * This method to handle change the screen
   * CV Community Vendor screen
   * NV non Community Vendor screen
   * C create Vendor screen
   * OE old Link Expired Vendor screen
   * LE Link Expired Vendor screen
   */
  statusUpdate(action: string) {
    switch (action) {
      case 'CV':
        this.showDetailForm = false;
        this.alreadyCreated = false;
        this.oldLinkExpired = false;
        this.linkExpired = false;
        this.registerSuccess = true;
        break;
      case 'NV':
        this.showDetailForm = false;
        this.alreadyCreated = false;
        this.oldLinkExpired = false;
        this.linkExpired = false;
        this.registerSuccess = true;
        break;
      case 'C':
        this.showDetailForm = false;
        this.alreadyCreated = true;
        this.oldLinkExpired = false;
        this.linkExpired = false;
        this.registerSuccess = false;
        break;
      case 'OE':
        this.showDetailForm = false;
        this.alreadyCreated = false;
        this.oldLinkExpired = true;
        this.linkExpired = false;
        this.registerSuccess = false;
        break;
      case 'LE':
        this.showDetailForm = false;
        this.alreadyCreated = false;
        this.oldLinkExpired = false;
        this.linkExpired = true;
        this.registerSuccess = false;
        break;
    }
  }
}
